import { render, staticRenderFns } from "./wy-target-number-2-values.vue?vue&type=template&id=89737578&"
import script from "./wy-target-number-2-values.vue?vue&type=script&lang=js&"
export * from "./wy-target-number-2-values.vue?vue&type=script&lang=js&"
import style0 from "./wy-target-number-2-values.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports